import { ColProps } from "./interfaces";
export const Td: React.FC<ColProps> = ({ name }) => {
  return <td className="px-5 py-3 text-sm text-tableColor">{name}</td>;
};
